import { IonAccordionGroup } from "@ionic/react";
import { useState } from "react";
import { jobs } from "../../variables/jobsDictionnary";
import "../IonColor/color.css";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import "../generalCSS/stylesheet.css";
import ItemTechno from "./ItemTechno";
import "./Welcome.css";

interface ContainerProps {
  endpoint: string;
  pathLogo: string;
}
const Welcome: React.FC<ContainerProps> = ({ pathLogo }) => {
  const [displayPole, setDisplayPole] = useState<boolean[]>([false, false]);

  const handleClick = (index: number) => {
    displayPole[index === 1 ? 0 : 1] = false;
    displayPole[index] = !displayPole[index];
    setDisplayPole([displayPole[0], displayPole[1]]);
  };

  return (
    <BasicPage
      title="Modules de Formation"
      subtitle=""
      pathLogo={pathLogo}
      sizeLg="4"
      sizeSm="8"
    >
      <IonAccordionGroup>
        {jobs
          .get(localStorage.getItem("techno") ?? "")
          ?.itemsWelcome?.map((item, i) => {
            return <ItemTechno key={i} index={i} depth={0} item={item} />;
          })}
      </IonAccordionGroup>
      {/* <div
        style={{
          marginTop: 60,
          marginBottom: 20,
          padding: 10,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: "#FFF5E5",
        }}
      >
        <IonText
          style={{
            color: "#4a4a4a",
            textAlign: "center",
          }}
        >
          Application et site web développés par LYS Agency
        </IonText>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <a href="mailto:agencyLYS@outlook.com?subject=Demande de renseignements&amp;body=Bonjour, j'aimerais avoir plus de renseignements sur mon projet. Est-ce que vous pouvez me recontacter ? Je vous souhaite une bonne journée">
            <IonText
              style={{
                color: "#fc7777",
              }}
            >
              agencyLYS@outlook.com
            </IonText>
          </a>
        </div>
      </div> */}
    </BasicPage>
  );
};

export default Welcome;
